/**
 * Função para formatar o nome da unidade: extrai código e nome, formata como "Nome (código)"
 * @param name - Nome da unidade no formato "código. Nome" (ex: "011. Americana - SP" ou "c005. Nome")
 * @returns Objeto com `formatted` (nome formatado como "Nome (código)") e `nameOnly` (apenas o nome)
 */
export const formatUnitName = (name: string): { formatted: string; nameOnly: string } => {
  // Extrai código (ex: "011" ou "c005") e nome (ex: "Americana - SP")
  const match = name.match(/^\s*([cC]?\d+)\.\s*(.+)$/);
  if (match) {
    const code = match[1];
    const nameOnly = match[2].trim();
    return { formatted: `${nameOnly} (${code})`, nameOnly };
  }
  return { formatted: name.trim(), nameOnly: name.trim() };
};
